module.exports = __webpack_public_path__ + "img/icon-wallet.7b02be81.svg";